import { } from "antd";
import { } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
//判断js是否引入
const isInclude = (name) => {
    var js = /js$/i.test(name);
    var es = document.getElementsByTagName(js ? "script" : "link");
    for (var i = 0; i < es.length; i++)
        if (es[i][js ? "src" : "href"].indexOf(name) !== -1) return true;
    return false;
};
//动态引入JS css（不加不行）
const file = (script, css) => {
    return new Promise((resolve) => {
        css = css || [];
        css.map((v) => {
            let link = document.createElement("link");
            link.rel = "stylesheet";
            link.async = false;
            link.href = v;
            if (!isInclude(v)) {
                document.head.appendChild(link);
            }
            return "";
        });
        let loads = script.map((v) => {
            let script = document.createElement("script");
            script.type = "text/javascript";
            script.async = false;
            script.src = v;
            if (!isInclude(v)) {
                document.head.appendChild(script);
            } else {
                setTimeout(() => {
                    resolve();
                }, 1000);
            }
            // uu
            return script;
        });
        let end = loads.pop();
        end.onload = resolve;
    });
};

const App = ({ value = [43.84866714477539, 125.31898498535156], onChange, height = "100vh" }) => {
    const [latlng, setLatlng] = useState(value);
    const refContainer = useRef(null);
    let marker = {};
    useEffect(() => {
        //页面打开就开始加载这两个文件
        file(
            ["http://111.26.70.125:9000/bigemap.js/v2.1.0/bigemap.js"],
            ["http://111.26.70.125:9000/bigemap.js/v2.1.0/bigemap.css"]
        ).then(() => {
            intbigmap();
        });

        // eslint-disable-next-line
    }, []);
    //加载后执行
    const intbigmap = () => {
        //地图规则设置地址
        window.BM.Config.HTTPS_URL = "https://111.26.70.125:9001";
        // window.BM.Config.FORCE_HTTPS = true;
        //有用
        window.BM.Config.HTTP_URL = "http://111.26.70.125:9000";
        let BM = window.BM;
        //用容器承载(承载地图)
        let map = BM.map(refContainer.current, "bigemap.52pzklol", {
            crs: BM.CRS.EPSG4326,
            //中心点
            center: [latlng[0], latlng[1]],
            //缩放级别
            zoom: 12,
            zoomControl: 0,
        });
        //设置地图级别
        map.setView(latlng, 15);

        map.on("click", function (e) {
            if (marker) {
                marker.remove();
            }
            Marker_add(e.latlng.lat, e.latlng.lng, BM, map);
            setLatlng([e.latlng.lat, e.latlng.lng]);
            onChange?.([e.latlng.lat, e.latlng.lng]);
        });

        // 添加marker
        addMarker(BM, map);
    };
    //将新增点封装在函数
    const addMarker = (BM, map) => {
        marker = BM.marker([latlng[0], latlng[1]], {
            //打点成功
            draggable: true,//这个参数可拖动
        }).addTo(map);

        marker.on("move", function (e) {
            //将地图点回显到上一页
            setLatlng([e.latlng.lat, e.latlng.lng]);
            onChange?.([e.latlng.lat, e.latlng.lng]);
        });
    };
    const Marker_add = (lat, lng, BM, map) => {
        if (marker) {
            marker.remove();
        }
        let marker_add = BM.marker([lat, lng], {
            draggable: true,
        }).addTo(map);
        marker = marker_add;
        map.setView([lat, lng]);
        marker_add.on("move", function (e) {
            setLatlng([e.latlng.lat, e.latlng.lng]);
            onChange?.([e.latlng.lat, e.latlng.lng]);
        });
    };

    return (
        <div
            ref={refContainer}
            style={{ width: "100%", height: height, position: "relative" }}
        ></div>
    );
};

export default App;
